import { render, staticRenderFns } from "./ChecktestQuestion.vue?vue&type=template&id=2db5bb09&"
import script from "./ChecktestQuestion.vue?vue&type=script&lang=ts&"
export * from "./ChecktestQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports